export enum ContentStatus {
  UPLOADED = 'uploaded',
  PENDING_AUTO = 'pending-auto',
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  PRE_RELEASE = 'pre-release', // Content that is approved but not yet ready to be active (e.g. Vertical Video)
  ACTIVE = 'active',
  INACTIVE = 'inactive', // Content is inactive but encodings still exist
  DELETED = 'deleted', // Content is inactive and encodings have been deleted
}
